
import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from '@angular/core';
import {  NbDialogService } from '@nebular/theme';
import * as _ from 'lodash';
import { TranslationService } from '../../language/translation.service';

@Component({
  selector: 'app-edit-attach',
  templateUrl: './edit-attach.component.html',
  styleUrls: ['./edit-attach.component.scss']
})
export class EditAttachComponent implements OnInit {
  @Output() emitClose = new EventEmitter();
  @Output() emitList = new EventEmitter();
  @Input() orgData: PRDAttachItemReq;  //已選資料_來源
  @Input() info: {
    IsLoding:false,
    moType: number ;//目前編輯狀態 1.新增 2.編輯 4.查看
    selectType:number; //1:單選 2:複選
    isRequired:number;//必填
  }; 
  @ViewChild('Modal') Modal :TemplateRef<any>
  
  
  modalRef = null;  //談窗鉤子

  //編輯附加品項談窗中 資料
  att: PRDAttachItemReq;


  //---------------選項列表-------->--------------//
  //稅率列表
  TaxRateList = []
  TaxTypeList = [
    {value:1,content:"免稅"},
    {value:2,content:"應稅"},
    {value:3,content:"零稅"}]
 //-------<--------選項列表----------------------//



  constructor(
    private dialogService: NbDialogService,
    private translationService: TranslationService,
  ) {

    

  }

  ngOnInit(): void {

    for(let i = 1 ; i<100;i++ ){
      this.TaxRateList.push({value:i , content:i+'%'})
    }
  }

  ngAfterViewInit(){   
    this.onOpen(this.info, this.orgData)
  }

  onOpen(info,data){
    if(info)
      this.info = info
    
    if(data)
      this.orgData = data


    this.att = new PRDAttachItemReq();
    


    if(this.info.moType == 1){
        //新增群組資料
       
        
        this.att= new PRDAttachItemReq();
        this.att.IsSell = true;
        this.att.TaxRate = 5;
        this.att.TaxType = 2;
        this.att.MinSelectTimes = this.info.isRequired == 1 ? 1 : 0;
        this.att.MaxSelectTimes = 1;
        this.att.SaleCash = 0      
        this.att.Cash = 0      
        this.att.Quantity = 1
       
    }
    else if(this.info.moType == 2){
     
      this.att = _.cloneDeep(this.orgData)
    }
    else if(this.info.moType == 4){
      this.att = _.cloneDeep(this.orgData)
    }
  

    
   
    this.modalRef = this.dialogService.open(this.Modal, {})
    this.modalRef.onClose.subscribe(result => {
      this.emitClose.emit(true);
    });

  
  }

  onSave(){

  
    this.emitList.emit(this.att)
    this.modalRef.close()
  }

  tt(key: string, fallback: string): string {
    const text = this.translationService.getText(key);
    return !text || text === key ? fallback : text;
  }

 






  
 
  


}











export class PRDAttachItemReq {
  PRDProductGroupNo: string//商品群組編號
  PRDAttachItemNo: string;//附加品項編號
  PRDProductNo: string;//商品編號  
  ItemName: string;//附加品項名稱
  TaxRate:number;
  TaxType:number;
  Note:string;
  Quantity: number;//數量
  Cash: number;//金額
  MaxSelectTimes:number; //最多可選
  MinSelectTimes:number; //最少可選
  SaleCash: number;//販售金額
  IsSell: boolean;//是否販售
  
  Sorting: number;//排序
}
